module.exports = __webpack_public_path__ + "img/fifth.d2877590.png";